import {ClientDetails} from '@app/interfaces/ClientDetails';

export const OFFER_REVISION = '2026-10-27';

const POLICY_MODAL_SHOWN_KEY = 'at.ug.policy-modal-shown';

type PolicyConsentClient = {
    isOfferRequired?: boolean | null;
    acceptedOffer?: unknown;
    personalDataAgreement?: unknown;
} | null;

const shownThisPageLoad = new Set<string>();

let openPolicyModal: (() => void) | null = null;
let pendingConsent: Promise<boolean> | null = null;
let resolvePendingConsent: ((accepted: boolean) => void) | null = null;

const policyModalStorageKey = (login: string) => `${POLICY_MODAL_SHOWN_KEY}:${login}`;

export const isPolicyConsentRequired = (clientDetails?: PolicyConsentClient): boolean => {
    if (!clientDetails) {
        return false;
    }

    if (clientDetails.isOfferRequired === true) {
        return clientDetails.acceptedOffer == null || clientDetails.personalDataAgreement == null;
    }

    return clientDetails.personalDataAgreement == null;
};

/**
 * показываем окно один раз за сессию вкладки.
 */
export const shouldShowPolicyModalOnEntry = (login: string, consentRequired: boolean): boolean => {
    if (!login || !consentRequired) {
        return false;
    }

    if (shownThisPageLoad.has(login)) {
        return true;
    }

    try {
        if (sessionStorage.getItem(policyModalStorageKey(login)) === '1') {
            return false;
        }

        sessionStorage.setItem(policyModalStorageKey(login), '1');
    } catch {
        // если sessionStorage недоступен, показ живёт только до перезагрузки
    }

    shownThisPageLoad.add(login);
    return true;
};

export const markPolicyModalClosed = (login: string) => {
    shownThisPageLoad.delete(login);
};

export const registerPolicyConsentOpener = (open: () => void) => {
    openPolicyModal = open;

    return () => {
        if (openPolicyModal === open) {
            openPolicyModal = null;
        }
    };
};

export const requestPolicyConsent = () => {
    if (pendingConsent) {
        return pendingConsent;
    }

    if (!openPolicyModal) {
        return Promise.resolve(false);
    }

    const open = openPolicyModal;

    pendingConsent = new Promise<boolean>((resolve) => {
        resolvePendingConsent = resolve;
    });

    open();

    return pendingConsent;
};

export const settlePolicyConsent = (accepted: boolean) => {
    const resolve = resolvePendingConsent;
    resolvePendingConsent = null;
    pendingConsent = null;
    resolve?.(accepted);
};

const acceptedNow = () => new Date().toISOString();

export const mergeAcceptedConsent = (
    details: ClientDetails,
    accepted: {offer: boolean; personal: boolean}
): ClientDetails => {
    const createdAt = acceptedNow();

    return {
        ...details,
        acceptedOffer:
            accepted.offer && details.acceptedOffer == null
                ? {
                      offer: {
                          revision: OFFER_REVISION,
                          isActual: true,
                          text: '',
                          url: '',
                          id: 0,
                          createdAt
                      },
                      clientIp: '',
                      userAgent: '',
                      createdAt
                  }
                : details.acceptedOffer,
        personalDataAgreement:
            accepted.personal && details.personalDataAgreement == null
                ? {
                      clientIp: '',
                      userAgent: '',
                      createdAt
                  }
                : details.personalDataAgreement
    };
};
